// extracted by mini-css-extract-plugin
module.exports = {"buttonClass":"styles_buttonClass__9rAnr","isTextView":"styles_isTextView__y2yow","phoneLink":"styles_phoneLink__EUdGW","phoneLinkDetail":"styles_phoneLinkDetail__4AwVf","greenPhoneLink":"styles_greenPhoneLink__yffW_"};
module.exports.__checksum = "66d48acefa91"
